export default __webpack_public_path__ + "static/media/rewards_poster_sample_en.5671d623.png";